module.exports = __webpack_public_path__ + "img/教学日报.36b29bb3.png";